import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

const metafieldConfig = z.object({
  namespace: z.string(),
  key: z.string(),
  value: z.string(),
});
export type MetafieldConfig = z.infer<typeof metafieldConfig>;

const addTagOperation = z.object({
  teamId: zExt.objectId(),
  deliveryProfileId: z.number(),
  operation: z.literal("addTag"),
  tag: z.string(),
});
export type AddTagOperation = z.infer<typeof addTagOperation>;

const addMetafieldOperation = z.object({
  teamId: zExt.objectId(),
  deliveryProfileId: z.number(),
  operation: z.literal("addMetafield"),
  metafield: metafieldConfig,
});
export type AddMetafieldOperation = z.infer<typeof addMetafieldOperation>;

const bulkUpdateInput = z.discriminatedUnion("operation", [
  addTagOperation,
  addMetafieldOperation,
]);
export type BulkUpdateInput = z.infer<typeof bulkUpdateInput>;

export const bulkUpdateDeliveryProfileProducts = {
  name: "bulkUpdateDeliveryProfileProducts" as const,
  input: bulkUpdateInput,
  output: z.object({
    successCount: z.number(),
    failureCount: z.number(),
    totalProducts: z.number(),
  }),
};
